var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-row",
        [
          !_vm.readonly
            ? _c(
                "b-col",
                { staticClass: "form-group", attrs: { sm: "6" } },
                [
                  _c("form-write-group-label-input", {
                    attrs: {
                      isMandatory: "",
                      inputLabel: _vm.$t("common.email.email_sender_name"),
                    },
                    model: {
                      value: _vm.SenderName,
                      callback: function ($$v) {
                        _vm.SenderName = $$v
                      },
                      expression: "SenderName",
                    },
                  }),
                ],
                1
              )
            : _c(
                "b-col",
                { staticClass: "form-group", attrs: { sm: "6" } },
                [
                  _c("form-read-group-label-input", {
                    attrs: {
                      isMandatory: "",
                      inputLabel: _vm.$t("common.email.email_sender_name"),
                      inputValue: _vm.SenderName,
                    },
                  }),
                ],
                1
              ),
          _vm._v(" "),
          !_vm.readonly
            ? _c(
                "b-col",
                { staticClass: "form-group", attrs: { sm: "6" } },
                [
                  _c("form-write-group-label-input", {
                    attrs: {
                      isMandatory: "",
                      inputLabel: _vm.$t("common.email.email_sender_email"),
                    },
                    model: {
                      value: _vm.SenderEmail,
                      callback: function ($$v) {
                        _vm.SenderEmail = $$v
                      },
                      expression: "SenderEmail",
                    },
                  }),
                ],
                1
              )
            : _c(
                "b-col",
                { staticClass: "form-group", attrs: { sm: "6" } },
                [
                  _c("form-read-group-label-input", {
                    attrs: {
                      isMandatory: "",
                      inputLabel: _vm.$t("common.email.email_sender_email"),
                      inputValue: _vm.SenderEmail,
                    },
                  }),
                ],
                1
              ),
          _vm._v(" "),
          !_vm.readonly
            ? _c(
                "b-col",
                { staticClass: "form-group", attrs: { sm: "6" } },
                [
                  _c("form-write-group-label-input", {
                    attrs: {
                      isMandatory: "",
                      inputLabel: _vm.$t(
                        "common.email.email_sender_smtp_server"
                      ),
                    },
                    model: {
                      value: _vm.SmtpServer,
                      callback: function ($$v) {
                        _vm.SmtpServer = $$v
                      },
                      expression: "SmtpServer",
                    },
                  }),
                ],
                1
              )
            : _c(
                "b-col",
                { staticClass: "form-group", attrs: { sm: "6" } },
                [
                  _c("form-read-group-label-input", {
                    attrs: {
                      isMandatory: "",
                      inputLabel: _vm.$t(
                        "common.email.email_sender_smtp_server"
                      ),
                      inputValue: _vm.SmtpServer,
                    },
                  }),
                ],
                1
              ),
          _vm._v(" "),
          !_vm.readonly
            ? _c(
                "b-col",
                { staticClass: "form-group", attrs: { sm: "6" } },
                [
                  _c("form-write-group-label-input", {
                    attrs: {
                      isMandatory: "",
                      inputLabel: _vm.$t("common.email.email_sender_smtp_port"),
                    },
                    model: {
                      value: _vm.SmtpPort,
                      callback: function ($$v) {
                        _vm.SmtpPort = $$v
                      },
                      expression: "SmtpPort",
                    },
                  }),
                ],
                1
              )
            : _c(
                "b-col",
                { staticClass: "form-group", attrs: { sm: "6" } },
                [
                  _c("form-read-group-label-input", {
                    attrs: {
                      isMandatory: "",
                      inputLabel: _vm.$t("common.email.email_sender_smtp_port"),
                      inputValue: _vm.SmtpPort,
                    },
                  }),
                ],
                1
              ),
          _vm._v(" "),
          !_vm.readonly
            ? _c(
                "b-col",
                { staticClass: "form-group", attrs: { sm: "6" } },
                [
                  _c("form-write-group-label-input", {
                    attrs: {
                      isMandatory: "",
                      inputLabel: _vm.$t("common.email.email_sender_smtp_user"),
                    },
                    model: {
                      value: _vm.SmtpUser,
                      callback: function ($$v) {
                        _vm.SmtpUser = $$v
                      },
                      expression: "SmtpUser",
                    },
                  }),
                ],
                1
              )
            : _c(
                "b-col",
                { staticClass: "form-group", attrs: { sm: "6" } },
                [
                  _c("form-read-group-label-input", {
                    attrs: {
                      isMandatory: "",
                      inputLabel: _vm.$t("common.email.email_sender_smtp_user"),
                      inputValue: _vm.SmtpUser,
                    },
                  }),
                ],
                1
              ),
          _vm._v(" "),
          !_vm.readonly
            ? _c(
                "b-col",
                { staticClass: "form-group", attrs: { sm: "6" } },
                [
                  _c("form-write-group-label-input", {
                    attrs: {
                      isMandatory: "",
                      inputLabel: _vm.$t(
                        "common.email.email_sender_smtp_password"
                      ),
                    },
                    model: {
                      value: _vm.SmtpPassword,
                      callback: function ($$v) {
                        _vm.SmtpPassword = $$v
                      },
                      expression: "SmtpPassword",
                    },
                  }),
                ],
                1
              )
            : _c(
                "b-col",
                { staticClass: "form-group", attrs: { sm: "6" } },
                [
                  _c("form-read-group-label-input", {
                    attrs: {
                      isMandatory: "",
                      inputLabel: _vm.$t(
                        "common.email.email_sender_smtp_password"
                      ),
                      inputValue: _vm.SmtpPassword,
                    },
                  }),
                ],
                1
              ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }